<template>
    <header class="--bgSolid --withBorder d-flex justify-content-between align-items-center">

        <div class="d-flex align-items-center">

            <router-link to="/">
                <img class="img-fluid header__logo" src="assets/img/adoptuj-kravicku-logo.svg" alt="adoptuj-kravicku-logo">
            </router-link>

            <ul class="skolske-menu">
                <li :class="{ active: $route.name === 'skoly-dashboard' }">
                    <router-link to="/skoly">
                        Úvod
                    </router-link>
                </li>
                <li :class="{ active: $route.name === 'skoly-ulohy' }">
                    <router-link :to="{ name: 'skoly-ulohy', params: { 'rocnik': profil.pouzivatel_id.pouzivatel_rocnik } }">
                        Naše úlohy
                    </router-link>
                </li>
                <li :class="{ active: $route.name === 'skoly-trieda' }">
                    <router-link :to="{ name: 'skoly-trieda' }">
                        Naša trieda
                    </router-link>
                </li>
            </ul>
        </div>

        <menu-user
                v-if="profil.pouzivatel_id"
                :profil="profil"
                :is-type-skoly="true"
        />

    </header>
</template>

<script>
import MenuUser from '../partials/MenuUser.vue'
export default {
    components: {
        MenuUser
    },
    props: [
        'profil'
    ],
    mounted() {
        this.toggleBodyClass('addClass', 'profile')
        if (typeof(this.profil.id) == "undefined" || this.profil.id === 0) {
            this.$emit('updateProfil')
        }
    },
    destroyed() {
        this.toggleBodyClass('removeClass', 'profile')
    },
    methods: {
        // mounted + destroy
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body
            if (addRemoveClass === 'addClass') {
                el.classList.add(className)
            } else {
                el.classList.remove(className)
            }
        }
    }
}
</script>
